(function () {
  'use strict';

  var STORAGE_KEY = 'qk_recommended_v1';
  var TTL_MS = 60 * 24 * 60 * 60 * 1000; // 60 days
  var BADGE_LABEL = 'Recommended For You';
  var BADGE_CLASS = 'qk-rec-badge';
  var BADGE_MARKER_ATTR = 'data-qk-rec-applied';
  var SOURCE_BLOCK_ID = 'qk-rec-source';
  var GRID_SELECTORS = [
    '.product-list--collection',
    '.product-list--search',
    '.products-slider',
    '.product-app--container',
    '.predictive-search',
    '.predictive-search__product-suggestions',
    '.predictive-search__results-list',
    '#' + SOURCE_BLOCK_ID
  ];

  function safeParse(json) {
    try { return JSON.parse(json); } catch (e) { return null; }
  }

  function readCache() {
    if (typeof localStorage === 'undefined') return null;
    var raw;
    try { raw = localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
    if (!raw) return null;
    var data = safeParse(raw);
    if (!data || typeof data !== 'object') return null;
    if (!data.expiresAt || data.expiresAt < Date.now()) {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      return null;
    }
    return {
      handles: Array.isArray(data.handles) ? data.handles : [],
      ids: Array.isArray(data.ids) ? data.ids.map(String) : [],
      expiresAt: data.expiresAt
    };
  }

  function writeCache(handles, ids) {
    if (typeof localStorage === 'undefined') return;
    var existing = readCache() || { handles: [], ids: [] };
    var nextHandles = uniqStrings(existing.handles.concat(handles || []));
    var nextIds = uniqStrings(existing.ids.concat((ids || []).map(String)));
    if (!nextHandles.length && !nextIds.length) return;
    var payload = {
      handles: nextHandles,
      ids: nextIds,
      expiresAt: Date.now() + TTL_MS
    };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(payload)); } catch (e) {}
  }

  function uniqStrings(arr) {
    var seen = Object.create(null);
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var v = arr[i];
      if (v == null) continue;
      var s = String(v).trim();
      if (!s || seen[s]) continue;
      seen[s] = true;
      out.push(s);
    }
    return out;
  }

  function extractHandleFromUrl(url) {
    if (!url) return null;
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function normalizeRecommendedProducts(list) {
    var handles = [];
    var ids = [];
    if (!Array.isArray(list)) return { handles: handles, ids: ids };
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (!p || typeof p !== 'object') continue;
      if (p.handle) handles.push(p.handle);
      else if (p.url) {
        var h = extractHandleFromUrl(p.url);
        if (h) handles.push(h);
      }
      if (p.id != null) ids.push(String(p.id).replace(/^gid:\/\/shopify\/Product\//, ''));
      if (p.product_id != null) ids.push(String(p.product_id));
    }
    return { handles: uniqStrings(handles), ids: uniqStrings(ids) };
  }

  function harvestFromSourceBlock() {
    var root = document.getElementById(SOURCE_BLOCK_ID);
    if (!root) return { handles: [], ids: [] };
    var anchors = root.querySelectorAll('a[href*="/products/"]');
    var handles = [];
    for (var i = 0; i < anchors.length; i++) {
      var h = extractHandleFromUrl(anchors[i].getAttribute('href'));
      if (h) handles.push(h);
    }
    return { handles: uniqStrings(handles), ids: [] };
  }

  function ensureBadgeSlot(card) {
    if (card.classList && card.classList.contains('product-badge-slot')) return card;
    var slot = card.querySelector(':scope > .product-badge-slot');
    if (slot) return slot;
    slot = card.querySelector('.product-badge-slot');
    if (slot) return slot;
    slot = document.createElement('div');
    slot.className = 'product-badge-slot product-badge-slot--qk-injected';
    if (card.firstChild) card.insertBefore(slot, card.firstChild);
    else card.appendChild(slot);
    return slot;
  }

  function badgeFor(card) {
    return card.querySelector('.' + BADGE_CLASS);
  }

  function cardMatches(card, handleSet, idSet) {
    var handle = card.getAttribute('data-qk-product-handle');
    if (handle && handleSet[handle]) return true;
    var id = card.getAttribute('data-qk-product-id');
    if (id && idSet[id]) return true;
    return false;
  }

  function buildBadge() {
    var el = document.createElement('span');
    el.className = BADGE_CLASS;
    el.textContent = BADGE_LABEL;
    el.setAttribute(BADGE_MARKER_ATTR, '1');
    return el;
  }

  function applyBadges() {
    var cache = readCache();
    if (!cache || (!cache.handles.length && !cache.ids.length)) return;
    var handleSet = Object.create(null);
    for (var i = 0; i < cache.handles.length; i++) handleSet[cache.handles[i]] = true;
    var idSet = Object.create(null);
    for (var j = 0; j < cache.ids.length; j++) idSet[cache.ids[j]] = true;

    var cards = document.querySelectorAll('[data-qk-product-handle], [data-qk-product-id]');
    for (var k = 0; k < cards.length; k++) {
      var card = cards[k];
      if (card.closest('#' + SOURCE_BLOCK_ID)) continue;
      if (badgeFor(card)) continue;
      if (!cardMatches(card, handleSet, idSet)) continue;
      var slot = ensureBadgeSlot(card);
      var emptyPlaceholder = slot.querySelector('.product-badge--empty');
      if (emptyPlaceholder && slot.children.length === 1) {
        emptyPlaceholder.parentNode.removeChild(emptyPlaceholder);
      }
      slot.appendChild(buildBadge());
    }
  }

  var scheduled = false;
  function scheduleApply() {
    if (scheduled) return;
    scheduled = true;
    var run = function () {
      scheduled = false;
      applyBadges();
    };
    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(run);
    } else {
      setTimeout(run, 16);
    }
  }

  function isInterestingMutation(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (!m.addedNodes || !m.addedNodes.length) continue;
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType !== 1) continue;
        if (n.matches && n.matches('[data-qk-product-handle], [data-qk-product-id]')) return true;
        if (n.querySelector && n.querySelector('[data-qk-product-handle], [data-qk-product-id]')) return true;
        for (var s = 0; s < GRID_SELECTORS.length; s++) {
          if (n.matches && n.matches(GRID_SELECTORS[s])) return true;
        }
      }
    }
    return false;
  }

  function observeDom() {
    if (typeof MutationObserver === 'undefined' || !document.body) return;
    var observer = new MutationObserver(function (mutations) {
      if (!isInterestingMutation(mutations)) return;
      // The hidden source block may have just rendered; harvest then apply.
      var harvested = harvestFromSourceBlock();
      if (harvested.handles.length) writeCache(harvested.handles, harvested.ids);
      scheduleApply();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function bindResultsEvent() {
    document.addEventListener('quizKitResultsPageLoaded', function (e) {
      var detail = e && e.detail;
      if (!detail) return;
      var norm = normalizeRecommendedProducts(detail.recommendedProducts);
      if (norm.handles.length || norm.ids.length) {
        writeCache(norm.handles, norm.ids);
        scheduleApply();
      }
    }, false);
  }

  function init() {
    bindResultsEvent();
    var harvested = harvestFromSourceBlock();
    if (harvested.handles.length) writeCache(harvested.handles, harvested.ids);
    applyBadges();
    observeDom();
  }

  window.QKRecBadge = {
    get: readCache,
    clear: function () {
      try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
      var existing = document.querySelectorAll('.' + BADGE_CLASS);
      for (var i = 0; i < existing.length; i++) {
        existing[i].parentNode && existing[i].parentNode.removeChild(existing[i]);
      }
    },
    refresh: function () {
      var harvested = harvestFromSourceBlock();
      if (harvested.handles.length) writeCache(harvested.handles, harvested.ids);
      applyBadges();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
